export default __webpack_public_path__ + "static/media/MDC_logo.21ac9752.png";